import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

import { LoanType } from '../../desking/models/enums';
import { FormPacket } from '../models/form-packet';

@Injectable()
export class FormPacketService {
  // private instance variable to hold base url
  private apiUrl = '/forms/formPackets';

  public add(formPacket: FormPacket): Observable<FormPacket> {
    const body = {
      packet: formPacket,
      forms: formPacket.forms.map(form => {
        return { key: form.id, value: form.name };
      })
    };
    return this.http.post(this.apiUrl, body);
  }

  public download(formPacketId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/download/${formPacketId}`, { responseType: 'blob' as 'blob' });
  }

  public get(packetId: number): Observable<FormPacket> {
    return this.http.get(`${this.apiUrl}/${packetId}`);
  }

  public getActives(configurationId: number): Observable<FormPacket[]> {
    return this.http.get(`${this.apiUrl}/getActives/${configurationId}`);
  }

  public getAll(configurationId: number): Observable<FormPacket[]> {
    return this.http.get(`${this.apiUrl}/getAll/${configurationId}`);
  }

  public getStampedPacketFiles(packetId: number, loanType: LoanType, eventId: number, paymentId: number): Observable<any> {
    const options = {
      responseType: 'blob' as 'blob',
      rethrowErrors: true
    };
    return this.http.get(`${this.apiUrl}/${packetId}/${loanType}/${eventId}/${paymentId}`, options);
  }

  public update(formPacket: FormPacket): Observable<FormPacket> {
    const body = {
      packet: formPacket,
      forms: formPacket.forms.map(form => {
        return { key: form.id, value: form.name };
      })
    };
    return this.http.put(`${this.apiUrl}/${formPacket.id}`, body);
  }

  constructor(private http: ApplicationHttpClient) {}
}
